import find from 'lodash/find';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import includes from 'lodash/includes';

import { extractFuels, getPlanTitle } from '@origin-digital/plans';

import { BENEFITS, NO_RENEWALS, SOLAR, NO_REWARDS, EVERYDAY_REWARDS } from './constants';

// tslint:disable:max-line-length
export const supplyPlanDesc = (title: string) =>
  `${title} is our easy, set-and-forget option. You’ll get our standard rates, and you don’t need to worry about renewing every year.`;
export const solarPlanDesc = (title: string) =>
  `${title} has our highest generally available feed-in tariff rate. Because your solar panels export energy back to the grid, ${title} could help you get paid more solar credits compared to our standard non-solar plans.`;
export const flexiPlanDesc = (title: string) =>
  `${title} gives you a great discount, with more freedom. When you sign up, you can choose whether or not you want direct debit and email bills.`;
export const homeSupportDesc = (title: string) => `Origin Basic + Allianz Home Assist is a 12-month plan giving you standard rates for your energy plus a 12-month membership to Allianz Global Assist, to support you with common home emergencies. You’re entitled to up to $300 (incl GST) towards two home callouts, with 24/7 access to qualified tradespeople in the Allianz network. Please note: this is a great option for emergency home repair support though the energy plan itself does not have our best advertised rates.`;
export const everydayRewardsDesc = (title: string) => `${title} is our energy plan with guaranteed rates for 12 months, flexible billing and payment options and you can add your Everyday Rewards membership details at sign up to start earning points with your energy usage.`;
export const goDesc = (title: string) => `${title} simplifies pricing by guaranteeing your rates for 12 months. It’s flexible too - no lock-in contract and you choose how to receive and pay your bills.`

export const getPlanDescription = (plan, answers: any = {}) => {
  const title = plan.title.toLowerCase();
  if (isSupplyPlan(plan)) {
    return supplyPlanDesc(plan.title);
  } else if (title.indexOf('flexi') > -1) {
    return flexiPlanDesc(plan.title);
  } else if (title.indexOf('home support') > -1) {
    return homeSupportDesc(plan.title);
  } else if (title.indexOf('origin go') > -1) {
    return answers.rewardType === EVERYDAY_REWARDS ? everydayRewardsDesc(plan.title) : goDesc(plan.title);
  } else if (title.indexOf('solar') > -1) {
    return solarPlanDesc(plan.title);
  }

  return '';
};

export const isSupplyPlan = (plan) => {
  const title = plan.title.toLowerCase();
  return title.indexOf('basic') > -1 || title.indexOf('supply') > -1;
};

export const getRecommendedPlan = (plans, answers) => {
  if (answers.planType === NO_RENEWALS) {
    return find(plans, isSupplyPlan);
  } else if (answers.planType === BENEFITS) {
    const { rewardType } = answers;

    if (rewardType === NO_REWARDS || rewardType === EVERYDAY_REWARDS) {
      return find(plans, (plan) => /Origin Go/i.test(plan.title));
    }

    return rewardType ? find(plans, (plan) =>
      plan.title.toLowerCase().indexOf(rewardType.toLowerCase()) > -1
    ) : null;
  } else if (answers.planType === SOLAR) {
    return find(plans, (plan) => /solar/i.test(plan.title));
  }
};

export const isEligible = (eligibilityStatus: string) =>
  includes(['01', '02', '04', '05'], eligibilityStatus);

export const isSolarAvailable = (plans): boolean => {
  return isArray(plans) && plans.some((plan) => get(plan.fuel, 'electricity.solarFit') !== null);
};

export const planTitle = (plan) => {
  const fuels = extractFuels(plan, 0, 0);
  return getPlanTitle(fuels, plan.title);
};
